import OSS from 'ali-oss'
import { purePost } from '../index'

const newClient = (data) => {
  let client = new OSS({
    endpoint: 'oss-accelerate.aliyuncs.com',
    // 云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
    accessKeyId: data.accessKeyId,
    accessKeySecret: data.accessKeySecret,
    stsToken: data.securityToken,
    bucket: data.bucketName
  })
  return client
}

// 拿到文件列表
const list = async (file, progressFn, { data }) => {
  let client = newClient(data)
  try {
    let result = await client.list({
      'max-keys': 100
    })
    return result
  } catch (err) {
    console.log(err)
  }
}

// put直接上传文件
// export const put = async (file) => {
//   let client = newClient()
//   try {
//     let result = await client.put(file.name, file)
//     return result
//   } catch (err) {
//     console.log(err)
//   }
// }

// 分片上传 + 5次断点续传
const multipartUpload = async (file, progressFn, { data }) => {
  let client = newClient(data)
  // 保存断点
  let checkpoint
  progressFn = progressFn || null
  // 断点上传5次
  for (let i = 0; i < 5; i++) {
    try {
      let result = await client.multipartUpload(data.md5name, file, {
        checkpoint,
        // 回调函数
        callback: {
          url: data.callBack,
          host: data.host,
          // eslint-disable-next-line no-template-curly-in-string
          body: 'bucket=${bucket}&filename=${object}&size=${size}&mimeType=${mimeType}&height=${imageInfo.height}&width=${imageInfo.width}&etag=&{etag}&fileId=' + data.fileId,
          contentType: 'application/x-www-form-urlencoded'
        },
        // 进度条
        async progress (percentage, cpt, res) {
          checkpoint = cpt
          progressFn(percentage, cpt, res)
        }
      })
      return result
    } catch (err) {
      console.log(err)
    }
  }
}
// 已有函数
const objFn = {
  multipartUpload,
  list
}

export default async (fnName, file, progressFn, businessId = null, tag = false) => {
  // alert(tag)
  let data = {
    originalName: file.name,
    tag: tag ? '0' : 'Default',
    dir: file.dir || ''
  }
  let url = file.url ? 'COMMON_GET_FILE_PUB_STS' : 'TEST_GET_FILE_STS'
  if (businessId) data.businessId = businessId
  const postCofig = () => {
    return new Promise((resolve, reject) => {
      purePost(url, data, (res) => {
        // 调用分片上传
        let name = fnName || 'multipartUpload'
        objFn[name](file, progressFn, res).then(result => {
          result.res = res.data
          resolve(result)
        }).catch(err => {
          reject(err)
        })
      }, (res) => {
        reject(res)
      }, (res) => {
        reject(res)
      })
    })
  }
  let e = await postCofig()
  return e
}



// WEBPACK FOOTER //
// ./src/assets/api/js/ali-oss.js